import React from "react";
import FieldError from "./FieldError";
import Tooltip from "../../utils/tooltip";

function PersonalInfoSection({
  language,
  USA_MODE,
  fullName,
  setFullName,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  dni,
  setDni,
  handleDniBlur,
  email,
  setEmail,
  setStoredValue,
  formErrors,
  emailError,
  dniStatusError,
}) {
  const t = {
    EN: {
      fullName: "Full name",
      name: "Name",
      lastName: "Last name",
      dni: "ID Number",
      email: "Email",
      dniPlaceholder: "Enter your ID number without dots or spaces",
      dniTitle: "Enter numbers only, between 6 and 10 digits",
      dniTooltip: "Enter your ID number without dots, spaces, or letters.",
    },
    ES: {
      fullName: "Nombre completo",
      name: "Nombre",
      lastName: "Apellido",
      dni: "DNI",
      email: "Email",
      dniPlaceholder: "Ingresá tu DNI/LC/LE, sin puntos ni espacios",
      dniTitle: "Ingresá solo números, entre 6 y 10 dígitos",
      dniTooltip: "Completá tu DNI sin puntos ni espacios y no agregues letras.",
    },
  };

  return (
    <>
      <div className="containerFlex">
        {USA_MODE ? (
          <>
            <div className="col-2">
              <label>
                <div>{t[language].fullName} <b>*</b></div>
              </label>
              <input
                type="text"
                name="full_name"
                value={fullName}
                onChange={(e) => {
                  setFullName(e.target.value);
                  setStoredValue("full_name", e.target.value);
                }}
                required
                minLength="3"
              />
              <FieldError error={formErrors.fullName} />
            </div>
          </>
        ) : (
          <>
            <div className="col-2">
              <label>
                <div>{t[language].name} <b>*</b></div>
              </label>
              <input
                type="text"
                name="first_name"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  setStoredValue("first_name", e.target.value);
                }}
                required
                minLength="3"
              />
              <FieldError error={formErrors.firstName} />
            </div>

            <div className="col-2">
              <label>
                <div>{t[language].lastName} <b>*</b></div>
              </label>
              <input
                type="text"
                name="last_name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  setStoredValue("last_name", e.target.value);
                }}
                required
                minLength="3"
              />
              <FieldError error={formErrors.lastName} />
            </div>
          </>
        )}
      </div>

      {!USA_MODE && (
        <div className="containerFlex">
          <div className="col-2">
            <label>
              <div>{t[language].dni} <b>*</b></div>
                <Tooltip text={t[language].dniTooltip}/>
            </label>
            <input
              className="match"
              type="text"
              inputMode="numeric"
              name="dni"
              value={dni}
              onChange={(e) => {
                setDni(e.target.value);
                setStoredValue("dni", e.target.value);
                sessionStorage.removeItem("edit_mode");
              }}
              onBlur={handleDniBlur}
              pattern="^\d{6,10}$"
              required
              placeholder={t[language].dniPlaceholder}
              title={t[language].dniTitle}
            />
            <FieldError error={formErrors.dni} />
            <FieldError error={dniStatusError} />
          </div>

          <div className="col-2">
            <label>
              <div>{t[language].email} <b>*</b></div>
            </label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setStoredValue("email", e.target.value);
              }}
              required
            />
            <FieldError error={formErrors.email} />
            <FieldError error={emailError} />
          </div>
        </div>
      )}
    </>
  );
}

export default PersonalInfoSection;
